<template>
  <span
    class="status-chip"
    :class="`status-chip--${isArchived ? 'archived' : status}`"
  >
    {{ isArchived ? 'Arhiviran' : statusLabels[status] }}
  </span>
</template>

<script setup>
defineProps({
  isArchived: {
    type: Boolean,
    required: true,
  },

  status: {
    type: String,
    required: true,
  },
})

const statusLabels = {
  active: 'Aktivni',
  past: 'Prošli',
  upcoming: 'Nadolazeći',
}
</script>
